export default __webpack_public_path__ + "static/media/claims1.1b0ec04e.jpg";